import React from 'react';
import { UserPlus, Gamepad2, TrendingUp, Award, HelpCircle, ArrowRight } from 'lucide-react';
import { STEPS, SITE, SOCIALS } from '../mock';
import { useReveal } from '../hooks/useReveal';

const ICONS = [UserPlus, Gamepad2, TrendingUp, Award];

const HELP = [
  ['Referral link', 'Your Roobet account must be registered with code ASIANRISK. Accounts not referred under ASIANRISK do not appear.'],
  ['Update delay', 'Standings refresh about every 60 seconds, and Roobet data itself can lag behind recent play.'],
  ['Qualifying activity', 'Only qualifying wagers count, weighted by game RTP under the counting rules, so totals may differ from your Roobet stats.'],
  ['Still missing?', 'Open a support ticket on Discord with your Roobet username.'],
];

const StepLink = ({ link, n }) => {
  const ext = link.type === 'roobet';
  return (
    <a href={ext ? SITE.roobetRef : link.href} target={ext ? '_blank' : undefined} rel={ext ? 'noopener noreferrer' : undefined}
      data-testid={`how-step-${n}-link`} className="mt-4 inline-flex items-center gap-1.5 text-sm font-display font-bold text-cyan hover:gap-2.5 transition-all">
      {link.label} <ArrowRight size={14} aria-hidden="true" />
    </a>
  );
};

export default function HowItWorks() {
  useReveal();
  return (
    <section id="how" className="py-16 sm:py-24 relative">
      <div className="ar-container">
        <div className="text-center mb-10 sm:mb-14 reveal">
          <p className="ar-eyebrow mb-3">Get Started</p>
          <h2 className="ar-heading text-3xl sm:text-4xl md:text-5xl mb-4">How It <span className="text-cyan">Works</span></h2>
          <p className="text-muted max-w-2xl mx-auto">Four steps from signing up to claiming a prize.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <div key={s.n} data-testid={`how-step-${s.n}`} className="ar-panel ar-panel-hover p-6 relative flex flex-col reveal" style={{ animationDelay: `${i * 0.1}s` }}>
                <span className="absolute top-5 right-6 font-display font-bold text-4xl" style={{ color: 'rgba(0,217,255,0.12)' }} aria-hidden="true">{s.n}</span>
                <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{ background: 'rgba(0,217,255,0.1)', border: '1px solid rgba(0,217,255,0.3)' }}>
                  <Icon size={22} className="text-cyan" aria-hidden="true" />
                </div>
                <h3 className="font-display font-bold text-lg mb-2"><span className="sr-only">Step {s.n}: </span>{s.title}</h3>
                <p className="text-sm text-muted leading-relaxed flex-1">{s.text}</p>
                <StepLink link={s.link} n={s.n} />
              </div>
            );
          })}
        </div>

        <div className="ar-panel p-6 sm:p-8 mt-8 reveal" data-testid="not-appearing-panel">
          <h3 className="font-display font-bold text-lg mb-5 flex items-center gap-2"><HelpCircle size={20} className="text-cyan" aria-hidden="true" /> Not appearing on the leaderboard?</h3>
          <dl className="grid sm:grid-cols-2 gap-5">
            {HELP.map(([k, v]) => (
              <div key={k}><dt className="font-display font-bold text-sm mb-1">{k}</dt><dd className="text-sm text-muted leading-relaxed">{v}</dd></div>
            ))}
          </dl>
          <a href={SOCIALS.discord} target="_blank" rel="noopener noreferrer" data-testid="not-appearing-discord-btn" className="btn-gold mt-6">CONTACT SUPPORT ON DISCORD</a>
        </div>
      </div>
    </section>
  );
}
